


















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

import router from "@/router";
import Endpoint from "@/utils/endpoint";
import Credential from "@/utils/credential";

const namespace = "auth";

interface ServerResponse {
  access_token: object;
}

interface Password {
  password: string;
  confirmPassword: string;
}

export type VForm = Vue & { validate: () => boolean } & {
  resetValidation: () => boolean;
};

@Component({})
export default class GeneratePassword extends Vue {
  private endpoint = new Endpoint();
  private credentials = new Credential();

  valid = true;
  feedBack = false;
  loading = false;
  feedbackTitle = "Success";
  feedbackMessage = ["Password registered successfully"];

  password: Password = { password: "", confirmPassword: "" };

  requiredRules: Array<any> = [
    (v: string) => {
      return !!v || "Required field";
    },
    (v: string) => {
      return (
        v === this.password.password ||
        "The password confirmation does not match."
      );
    }
  ];

  @Action("disconnectToken", { namespace }) disconnectToken: any;

  created() {
    this.disconnectToken();
  }

  get form(): VForm {
    return this.$refs.form as VForm;
  }

  closeModalMessage(): void {
    this.feedBack = false;
  }

  public generatePassword(): void {
    if (this.form.validate()) {
      this.loading = true;

      const data = {
        userId: this.$router.currentRoute.params.id,
        token: this.$router.currentRoute.query.token,
        newPassword: this.password.password
      };

      this.$http
        .put(this.endpoint.generatePassword, data, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then((res: any) => {
          if (res.succeeded) {
            this.password = { password: "", confirmPassword: "" };
            this.loading = false;
            this.feedBack = true;
            this.form;
            this.form.resetValidation();
            this.requiredRules.pop();
          } else {
            this.password = { password: "", confirmPassword: "" };
            this.loading = false;

            this.feedbackTitle = "Error";
            if (res.errors && res.errors.length > 0) {
              this.feedbackMessage = [];
              for (let i = 0; i < res.errors.length; i++) {
                if (res.errors[i].code == "InvalidToken") {
                  this.feedbackMessage.push(
                    "Your validation token is not valid, call to your Lest contact"
                  );
                } else {
                  this.feedbackMessage.push(res.errors[i].description);
                }
              }
            }

            this.feedBack = true;
          }
        })
        .catch(err => {
          console.error("error", err);

          this.requiredRules.push((v: string) => {
            return (
              !err.response.data.error_description ||
              "Incorrect username or password"
            );
          });

          this.loading = false;
          return false;
        });
    }
  }
}
